export function Spinner() {
    return <i className="spinner-border text-primary" />;
}

export function SpinnerSM() {
    return <i className="spinner-border spinner-border-sm text-primary" />;
}
